module.exports = __webpack_public_path__ + "static/media/espace-logo.d9843b2d.svg";